module.exports = "/_next/static/images/BestStack@2x-cdbe58b0a672f32627baeac3a0762562.png";